const config = {
  topMenu: false,
  rtl: false,
  darkMode: false,
  mainTemplate: 'lightMode',
  // mainTemplate: 'blackMode',
};

export default config;
